
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  logoutButton: {
    id: "Logout.button",
    defaultMessage: "Logout",
  }, 
});

export default MESSAGES;